import React, {Fragment} from 'react';
import {Grid, TextField, withStyles} from '@material-ui/core';
import styles from '../styles';
import PropTypes from "prop-types";
import classNames from 'classnames';

function TwitterfeedComponent(props) {
    const {classes, editComponent, component} = props;

    return (
        <Fragment>
            <Grid container className={classNames([classes.root, classes.rootHeightEncase])} spacing={16}>
                <Grid item md={4} xs={12} className={classes.rootHeightEncaseComponents}>
                    <TextField
                        value={component.Account || ''}
                        label="Twitter Account"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        onChange={e => editComponent('Account', e.target.value)}
                    />
                </Grid>
                <Grid item md={8} xs={12} className={classes.rootHeightEncaseComponents}>
                </Grid>
            </Grid>
        </Fragment>
    )
}

TwitterfeedComponent.propTypes = {
    classes: PropTypes.object,
    editComponent: PropTypes.func,
    component: PropTypes.object,
};

export default withStyles(styles)(TwitterfeedComponent);
